import React, { useEffect, useState } from "react";
import TaskHeader from "components/task/header/TaskHeader";
import TaskContent from "components/task/content/TaskContent";
import { Box, Stack } from "@mui/joy";
import { ProgramContentType } from "data/BlockComponent";
import { useRecoilValue } from "recoil";
import { ProgramType } from "data/programData";
import { patientAtom } from "../../recoil/patientAtom";
import useGetRetrospectData from "../../hooks/useGetRetrospectData";

export default function Retrospect({ taskKey }: { taskKey: string }) {
  const patient = useRecoilValue(patientAtom);

  const weekNumber = Number(taskKey.split(":")[0].split("_")[1]);

  const [data, setData] = useState<ProgramType | undefined>();

  const [contentData, setContentData] = useState<
    ProgramContentType[] | undefined
  >();

  const { data: fetchedData } = useGetRetrospectData({
    weekNumber: weekNumber,
  });

  useEffect(() => {
    if (fetchedData) {
      setData(fetchedData);
    }
  }, [fetchedData]);

  useEffect(() => {
    setContentData(data?.content);
  }, [data]);

  const [moveToIndex, setMoveToIndex] = useState<number | undefined>(undefined);

  return (
    <>
      <Box
        sx={{
          position: "sticky",
          top: 0,
          zIndex: 100,
        }}
      >
        <TaskHeader
          key={`retrospect-${patient?.patientId}-${weekNumber}`}
          taskKey={`retrospect-${patient?.patientId}-${weekNumber}`}
          title={`${weekNumber}주차 돌아보기`}
        />
      </Box>

      <Stack sx={{ flex: 1, overflow: "hidden" }}>
        <TaskContent
          taskKey={`0-3-W:${patient?.patientId}`}
          data={contentData}
          setData={setContentData}
          moveToIndex={moveToIndex}
          setMoveToIndex={setMoveToIndex}
          isDone={true}
          isOpen={false}
          translationVersion={data?.translationVersion}
        />
      </Stack>
    </>
  );
}
